import "bootstrap/dist/css/bootstrap.min.css";
import "fixed-data-table-2/dist/fixed-data-table.min.css";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./scripts/App";
import registerServiceWorker from "./scripts/registerServiceWorker";
import "./styles/index.css";
import store from "./scripts/store/Store";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root") as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx